
    <form [formGroup]="patientForm" enctype="multipart/form-data" onsubmit="event.preventDefault(); return false;" autocomplete="off">
    <div *ngIf="loading">
      <h3 style="text-align:center;">LOADING PATIENT</h3>
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
    <div *ngIf="!loading">


      <div class="ao-patient-summary">
        <div class="ao-patient-identity">
          <div class="ao-patient-avatar" aria-hidden="true">{{ patientInitials }}</div>
          <div>
            <h1>
              {{ patientDisplayName }}
              <span class="ao-patient-number" *ngIf="patient.patientNumber">(Patient #{{ patientNumberLabel }})</span>
            </h1>
            <p class="ao-patient-linked" *ngIf="headerLinks.length">
              <mat-icon>groups</mat-icon>
              <ng-container *ngFor="let link of headerLinks; let last = last">
                <button type="button" (click)="openLinkedPatient(link)">{{ linkLabel(link) }}</button>
                <span class="ao-patient-family-separator" *ngIf="!last">•</span>
              </ng-container>
            </p>
          </div>
        </div>
        <div class="ao-patient-status">
          <select
            aria-label="Patient status"
            [value]="patientStatus"
            (change)="setPatientStatus($any($event.target).value)"
          >
            <option>Active</option>
            <option>Sleep</option>
          </select>
          <label class="ao-patient-alert">
            <input
              type="checkbox"
              [checked]="patientForm.get('alertNotes')?.value"
              (change)="patientForm.get('alertNotes').setValue($any($event.target).checked)"
            >
            <mat-icon>notifications_none</mat-icon>
            <span>Alert</span>
          </label>
          <label class="ao-patient-dns">
            <input
              type="checkbox"
              [checked]="patientForm.get('dns')?.value"
              (change)="setPatientDns($any($event.target).checked)"
            >
            <span>DNS</span>
          </label>
        </div>
      </div>

      <div class="ao-patient-content">
        <section class="ao-patient-section">
          <header class="ao-section-head"><h2>Patient Information</h2></header>
          <app-form-patient [parentForm]="patientForm" [patient]="patient"></app-form-patient>
        </section>

        <section class="ao-patient-section">
          <header class="ao-section-head"><h2>Patient Notes</h2></header>
          <div class="ao-patient-section-body">
            <label class="ao-patient-note-label" for="patient-notes">Notes Used With Patient Orders</label>
            <ckeditor id="patient-notes" [editor]="ClassicEditorBuild" style="width:100%;" placeholder="PATIENT NOTES" [formControl]="patientForm.controls['patientNotes']" [config]="{toolbar: [ 'Bold', 'Italic' ]}" matInput></ckeditor>
          </div>
        </section>

        <mat-accordion class="ao-preferences-accordion">
          <mat-expansion-panel class="ao-preferences">
            <mat-expansion-panel-header class="ao-section-head">
              <mat-panel-title>PREFERENCES</mat-panel-title>
            </mat-expansion-panel-header>
            <div class="ao-preference-columns ao-fields">
              <section class="ao-preference-panel">
                <h3>Notifications</h3>
                <mat-form-field floatLabel="always">
                  <mat-label>NOTIFY BY</mat-label>
                  <mat-select formControlName="notifyChannel">
                    <mat-option value="EMAIL">EMAIL</mat-option>
                    <mat-option value="TEXT">TEXT</mat-option>
                    <mat-option value="BOTH">EMAIL AND TEXT</mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-checkbox formControlName="optOut">MARKETING OPT-OUT</mat-checkbox>
                <mat-form-field floatLabel="always">
                  <mat-label>DISCOUNT STATUS</mat-label>
                  <mat-select formControlName="discountStatus">
                    <mat-option value="">-</mat-option>
                    <mat-option value="SENIOR">SENIOR</mat-option>
                    <mat-option value="FRIENDSFAMILY">FRIENDS &amp; FAMILY</mat-option>
                    <mat-option value="EMPLOYEE">EMPLOYEE</mat-option>
                  </mat-select>
                </mat-form-field>
              </section>
              <section class="ao-preference-panel">
                <h3>Designer Interests</h3>
                <app-form-favorites [favorites]="patient.favoriteLines" [parentForm]="patientForm"></app-form-favorites>
                <mat-form-field floatLabel="always">
                  <mat-label>BE BACK LIST</mat-label>
                  <textarea matInput formControlName="beBackList" rows="4" autocomplete="off"></textarea>
                </mat-form-field>
              </section>
            </div>
            <div class="ao-linked-inline">
              <h3>Linked Patients</h3>
              <app-linked-patients [patient]="patient"></app-linked-patients>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>

      <div class="ao-patient-footer">
        <div class="ao-patient-footer-actions">
          <button mat-raised-button type="button" (click)="save()" [disabled]="saveButtonClicked || patientForm.invalid">SAVE</button>
          <button *ngIf="canCopy" mat-raised-button type="button" (click)="copyPatient()">COPY</button>
          <button mat-button type="button" *ngIf="authorized && !newPatient" (click)="deletePatient()">DELETE PATIENT</button>
        </div>
        <mat-progress-bar mode="indeterminate" *ngIf="saveButtonClicked"></mat-progress-bar>
      </div>

      <mat-accordion class="ao-patient-records" multi>
        <mat-expansion-panel *ngIf="false" (opened)="panelOpenStateInquiries = true" (closed)="panelOpenStateInquiries = false">
          <mat-expansion-panel-header [class.ao-section-head]="panelOpenStateInquiries">
            <mat-panel-title>
              INQUIRIES
            </mat-panel-title>
          </mat-expansion-panel-header>
          <app-patient-inquiries [patient]="patient" style="width:100%;"></app-patient-inquiries>
        </mat-expansion-panel>

        <mat-expansion-panel (opened)="onOrdersPanelOpened()" (closed)="panelOpenStateOrders = false">
          <mat-expansion-panel-header class="ao-record-head" [class.ao-record-open]="panelOpenStateOrders">
            <mat-panel-title>
              ORDERS
            </mat-panel-title>
          </mat-expansion-panel-header>
          <app-patient-orders
            *ngIf="ordersPanelLoaded"
            [patient]="patient"
            (clickDelete)="deleteOrder($event)"
            (clickReturn)="returnOrder($event)"
            (clickExchange)="exchangeOrder($event)"
            [storeCreditControl]="patientForm.controls['storeCredit']"
            style="width:100%;">

          </app-patient-orders>
        </mat-expansion-panel>



        <mat-expansion-panel *ngIf="false" (opened)="panelOpenStateDoctorInformation = true" (closed)="panelOpenStateDoctorInformation = false">
          <mat-expansion-panel-header [class.ao-section-head]="panelOpenStateDoctorInformation">
            <mat-panel-title>
              DOCTOR INFORMATION
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="item item-1">

            <div class="container" fxLayout="row" fxLayoutAlign="left" fxLayoutGap="10px" fxLayoutGap.xs="0">
              <div class="item item-1" fxFlex="50%">
                <mat-form-field style="width:100%">
                  <input autocomplete="off" matInput placeholder="NAME" type="text" formControlName="doctorName" autoComplete="off">
                </mat-form-field>
              </div>
              <div class="item item-2" fxFlex="20%">
                <mat-form-field class="date" style="width:100%;">
                  <input autocomplete="off" matInput [matDatepicker]="lastExam" placeholder="LAST EXAM" type="text" formControlName="lastExam">
                  <mat-datepicker-toggle matSuffix [for]="lastExam"></mat-datepicker-toggle>
                  <mat-datepicker #lastExam></mat-datepicker>
                  <mat-hint>MMDDYYYY</mat-hint>
                </mat-form-field>
              </div>
              <div class="item item-3" fxFlex="20%" fxFlexAlign="center">
                <mat-checkbox matInput formControlName="callForRx">CALL FOR Rx</mat-checkbox>
              </div>
            </div>
          </div>
          <div class="item item-1">
            <div class="container" fxLayout="row" fxLayoutAlign="left" fxLayoutGap="10px" fxLayoutGap.xs="0">
              <div class="item item-1" fxFlex="0 0 calc(25%-5px)">
                <mat-form-field style="width:100%">
                  <input matInput placeholder="PHONE" type="tel" formControlName="doctorPhone" (keyup)="phoneType($event,'doctorPhone')" autocomplete="off">
                </mat-form-field>
              </div>
              <div class="item item-2" fxFlex="0 0 calc(25%-5px)">
                <mat-form-field style="width:100%">
                  <input matInput placeholder="FAX #" type="tel" formControlName="doctorFax" (keyup)="phoneType($event,'doctorFax')" autocomplete="off">
                </mat-form-field>
              </div>
              <div class="item item-3" fxFlex>
                <mat-form-field style="width:100%">
                  <input matInput placeholder="EMAIL" type="email" formControlName="doctorEmail" autocomplete="off">
                </mat-form-field>
              </div>
            </div>
          </div>
        </mat-expansion-panel>

        <mat-expansion-panel (opened)="onPrescriptionsPanelOpened()" (closed)="panelOpenStatePrescriptions = false">
          <mat-expansion-panel-header class="ao-record-head" [class.ao-record-open]="panelOpenStatePrescriptions">
            <mat-panel-title>
              PRESCRIPTIONS
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ng-container *ngIf="prescriptionsPanelLoaded">
          <div class="item item-3">

                <button mat-raised-button type="button" (click)="importCustomerImages()">UPLOAD Rx IMAGES</button>

          </div>
          <div class="item">
            <app-prescriptions [patient]="patient"></app-prescriptions>
          </div>
          <div class="item item-4">
            <mat-toolbar class="ao-section-head">
              <span>Rx NOTES &amp; ADVICE</span>
            </mat-toolbar>


            <ckeditor [editor]="ClassicEditorBuild" style="width:100%;" placeholder="Rx NOTES & ADVICE" [formControl]="patientForm.controls['prescriptionNotes']" [config]="{toolbar: [ 'Bold', 'Italic' ]}" matInput></ckeditor>

          </div>
          </ng-container>
        </mat-expansion-panel>

        <mat-expansion-panel (opened)="onScannedOrdersPanelOpened()" (closed)="panelOpenStateScannedOrders = false">
          <mat-expansion-panel-header class="ao-record-head" [class.ao-record-open]="panelOpenStateScannedOrders">
            <mat-panel-title>
              SCANNED ORDERS
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="scanned-orders">
            <div class="scanned-toolbar">
              <p>Past scanned documents and complete PDFs created by AutoOptiq.</p>
              <button type="button" class="scanned-upload" (click)="importCustomerImages()">
                <mat-icon>upload</mat-icon>
                Upload Order
              </button>
            </div>
            <mat-progress-bar mode="determinate" [value]="uploaderOrder.progress" *ngIf="uploaderOrder.isUploading"></mat-progress-bar>
            <mat-progress-bar mode="indeterminate" *ngIf="scannedOrdersLoading"></mat-progress-bar>
            <app-form-order-image-group
              *ngIf="scannedOrdersFetched && !scannedOrdersLoading"
              [orders]="scannedOrders"
              (clickReturn)="returnOrder($event)"
              (clickExchange)="exchangeOrder($event)"
              (clickEmail)="emailOrder($event)"
              (clickSetAsPrescription)="setOrderAsPrescription($event)">
            </app-form-order-image-group>
          </div>
        </mat-expansion-panel>

      </mat-accordion>

  </div>
    </form>

